$(function () {
  var active = document.location.pathname.split("/")[1],
      activeMenu;

  if (!active) {
    active = "home";
  }

  if (document.location.pathname.indexOf("login") !== -1) {
    active = "home"
  }

  activeMenu = $(".js-header-navigation " + "." + active);

  activeMenu.removeClass("border-orange");
  activeMenu.removeClass("border-eggshell");
  activeMenu.addClass("border-white");

  activeMenu.removeClass("eggshell");
  activeMenu.addClass("white");

  // TODO: not working
  activeMenu.find("img").addClass("white");

  $('.expand-nav').on('click', function(event) {
    //Expand mobile nav
    $('.logo-nav-mobile, .inner-navigation').toggleClass('active');
  });

  $('.detail-subnav .active').on('click', function(event) {
    event.preventDefault();
    $(this).parents('.outer-container').toggleClass('active');
  });
});



// WEBPACK FOOTER //
// client/commons/navigation/bundle.js